export default [
  { id: 1, 작업내용: '조적미장공사',
    유해위험요인: '지게차로 자재 인양시 노면 돌출물 등에 의해 \n지게차가 흔들리면서 자재 낙하',
    개선대책: '1. 하역 장소 노면 돌출 사전제거\n' +
      '2. 유도자를 배치, 근로자 통제',
  },
  { id: 2, 작업내용: '조적미장공사',
    유해위험요인: '벽돌 등의 자재 적재 불량으로 생긴 편심하중에 \n의한 붕괴',
    개선대책: '1. 자재 적재시 수평으로 안정되게 적재',
  },
  { id: 3, 작업내용: '조적미장공사',
    유해위험요인: '지게차 등으로 인양 운반시 경고장치 미설치로 인해 근로자가 지게차와 충돌',
    개선대책: '1. 지게차 후면부에 경광등을 설치하여 지게차 운행 시 \n    경고 조치 수행',
  },
  { id: 4, 작업내용: '조적미장공사',
    유해위험요인: '안전모, 안전화 등 개인보호구 미착용으로 인해 \n' +
      '작업 중 부딪히거나 낙하물에 맞음',
    개선대책: '1. 자재 반입 및 운반시 안전모 등 개인보호구의 철저한 \n    착용',
  },
  { id: 5, 작업내용: '조적미장공사',
    유해위험요인: '통행로에 적재된 벽돌자재가 근로자 통행 중 쏟아짐',
    개선대책: '1. 벽돌 등의 자재 적재 시 통행에 지장이 없는 안전한 장소 선택',
  },
  { id: 6, 작업내용: '조적미장공사',
    유해위험요인: '이동식 비계의 안전난간대 및 승강 사다리 \n미설치로 인해 작업 중 추락',
    개선대책: '1. 이동식 비계 사용시 안전난간대, 승강사다리 설치',
  },
  { id: 7, 작업내용: '조적미장공사',
    유해위험요인: '야간작업시 투광등 누전에 의한 감전',
    개선대책: '1. 투광등 외함접지, 피복손상 여부 확인\n' +
      '2. 누전 차단기 설치 확인',
  },
  { id: 8, 작업내용: '조적미장공사',
    유해위험요인: '1일 쌓기의 높이 규정 미준수로 인해 \n벽돌 블럭쌓기 중 붕괴',
    개선대책: '1. 시방서에 따라 1일 쌓기의 높이 규정 준수 \n' +
      '2. 벽돌이나 블록 쌓기 시 수직도 유지',
  },
  { id: 9, 작업내용: '조적미장공사',
    유해위험요인: '시멘트 모르타르 비빔작업시 비빔용 기구에 감전',
    개선대책: '1. 시멘트 모르타르 비빔용 기구의 접지 확인 및 누전차단기\n    연결사용',
  },
  { id: 10, 작업내용: '조적미장공사',
    유해위험요인: '미장작업용 말비계를 벽돌위에 불안전하게 \n설치하여 작업 중 넘어짐',
    개선대책: '1. 말비계의 불안전한 설치 금지',
  },
  { id: 11, 작업내용: '조적미장공사',
    유해위험요인: '말비계를 계단실 등 경사진 곳에 설치하고 사용 중 추락',
    개선대책: '1. 경사로에 작업대 설치시 비계 등을 조립하여 수평으로 \n    설치',
  },
  { id: 12, 작업내용: '조적미장공사',
    유해위험요인: '그라인딩 작업시 분진 비산',
    개선대책: '1. 그라인딩 작업시 보안경, 방진마스크 착용',
  },
  { id: 13, 작업내용: '조적미장공사',
    유해위험요인: '이동식 비계 하부에 연결된 각재가 작업 중 \n부러지면서 이동식비계 넘어짐',
    개선대책: '1. 이동식 비계를 각재 등 이질 재료와 연결하여 사용하는 행위 금지',
  },
]
